import { getHasActiveOperatorRun } from './getHasActiveOperatorRun';
import { getLatestOperator } from './getLatestOperator';
import { getLatestOperatorRun } from './getLatestOperatorRun';

// How far ahead of this tablet's clock an open run's start may be and still count
// as signed in: covers a tablet clock running behind the server, not a run that
// genuinely starts later.
const CLOCK_SKEW_TOLERANCE_MS = 5 * 60 * 1000;

/**
 * Whether an operator is signed in on the machine. Based on the operator run
 * itself (getCurrentOperator also needs the operators list, which can still be
 * loading). Returns a primitive so selectors built on it stay stable.
 */
const getIsOperatorSignedIn = (state) => {
  const latestRun = getLatestOperatorRun(state);
  if (
    latestRun?.startAt &&
    latestRun.endAt === null &&
    new Date(latestRun.startAt).getTime() <=
      Date.now() + CLOCK_SKEW_TOLERANCE_MS
  ) {
    return true;
  }
  return Boolean(getHasActiveOperatorRun(state));
};

/** The signed-in (latest run's) operator's ERP person id, once loaded. */
const getSignedInOperatorErpId = (state) => {
  return getLatestOperator(state)?.erpId ?? null;
};

export { getIsOperatorSignedIn, getSignedInOperatorErpId };
